import axios from 'axios';

export const GET_TEMPLATES = 'lms/course-templates';
export const GET_FONTS = 'lms/course-typefaces';
export const GET_CUSTOM_FONTS = 'v3/custom_fonts';
export const GET_COURSE_CUSTOM_STYLE = '/v3/front/courses/{course_guid}/custom_styles';

export function getTemplates() {
  return axios.get(GET_TEMPLATES);
}

export function getFonts() {
  return axios.get(GET_FONTS);
}

export function getCustomFonts() {
  return axios.get(GET_CUSTOM_FONTS);
}

export function getCourseCustomStyle(courseGuid) {
  return axios.get(`${GET_COURSE_CUSTOM_STYLE.replace('{course_guid}', courseGuid)}`);
}
